export const RefereeAnswers = {//refereeAnswers - ENUM
    Empty: 0,
    TooBusy:100000000,
    ConflictOfInterests:100000001,
    MedicalReasons:100000002,
    Sabbatical:100000003,
    NotInMyField:100000004,
    ConflictOfInterestsButRecommendedOtherReferees:100000005,
    TooBusyButRecommendedOtherReferees:100000006,
    NotInFieldButRecommendedOtherReferees:100000007,
    AgreeToEvaluate:100000008,
    ForwardToColleague:100000009,
    Emeritus:100000010,
    WantsMoney:100000011,
    ParentalLeave:100000012,
    Retired:100000013,
    CannotServeAsRefereeInThisProposal:100000014,
    Protest:100000015,
    Other:100000016,
  };
export const refereeStatus = {//refereeStatus - ENUM
    empty: 0,
    potential:100000000,
    sentFirstMail:100000001,
    declinedEvaluating:100000002,
    enoughReviews:100000003,
    sentFirstMailReminder:100000004,
    evaluationEmailReminder:100000005,
    firstEmailSpecialReminder:100000007,
    agreeToEvaluate:100000011,
    sentEvaluation:100000012,
};

  export const Recommendations = [
    {
      label: "Outstanding",
      tooltip: "Outstanding - Highly recommendation for funding",
      value:100000000
    },
    {
      label: "Excellent",
      tooltip: "Excellent - Recommended for funding",
      value:100000001
    },
    {
      label: "Very Good",
      tooltip: "Very Good - Recommended for funding if budger permits",
      value:100000002
    },
    {
      label: "Good",
      tooltip: "Good - Not recommended for funding in present form",
      value:100000003
    },
    {
      label: "Weak",
      tooltip: "Weak - Major changes are required",
      value:100000004
    },
  ];

  export const recommendedBy={
    Advisor:100000000,
    GIFsInformationSpecialists:100000001,
    Referee:100000002,
    ApplicantSuggestedReviewer:100000004,
    Other:100000005,
    ApplicantReviewerNotToBeSent:100000006,
  }

  export const MAIN_PAGE_URL="/referee/dashboard";
  